import React, { useContext, useEffect, useState } from "react";
import { Alert, Collapse, IconButton, Snackbar } from "@mui/material";
import { Context } from "../states/Store";
import useStyles from "../style/js-style/components/EASnackBarStyle";
import i18next from "i18next";
import EASpinner from "./common/EASpinner";
import clsx from "clsx";
import { isEmpty } from "services/common/Utils";
import EAAlertIcon from "./common/EAAlertIcon";
import EAAlertCloseIcon from "./common/EAAlertCloseIcon";

const EASnackBar = () => {
  const [state, dispatch] = useContext(Context);
  const [alertOpen, setAlertOpen] = useState(false);
  const { classes } = useStyles();

  useEffect(() => {
    setAlertOpen(true);
  }, [state.alert]);

  const handleAlertClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertOpen(false);
  };
  const formatErrorMsg = (msg) => {
    if (React.isValidElement(msg)) {
      return msg;
    } else if (Array.isArray(msg)) {
      return (
        <>
          {msg.map((item, index) => {
            if (typeof item === "object") {
              return formatErrorMsg(item);
            } else {
              let listErrors = item.split(":").filter(s => !isEmpty(s) && s !== "null");
              if (listErrors.length > 1) {
                return (
                  <div key={index}>
                    {i18next.t("infos." + listErrors[0])}
                    <ul>
                      {listErrors[1].split("\\").map(m => (<li key={index}>{m}</li>))}
                    </ul>
                  </div>
                );
              } else {
                return (
                  <div key={index}>
                    {formatErrorMsg(listErrors[0])}
                  </div>
                )
              }
            }
          })}
        </>
      );
    } else if (typeof msg === "object") {
      if (msg?.code) {
        return i18next.t("infos." + msg.code) === "infos." + msg.code
          ? i18next.t(msg.message)
          : i18next.t("infos." + msg.code);
      }

      return formatErrorMsg(msg?.error);
    }

    return i18next.t("infos." + msg) === "infos." + msg
      ? i18next.t(msg)
      : i18next.t("infos." + msg);
  };

  return (
    state.alert && (
      <Collapse in={!!state.alert}>
        <Snackbar
          open={alertOpen}
          autoHideDuration={1500}
          onClose={handleAlertClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          className={clsx(classes.snackbar, `̀classes.snackbar-${state.alert.type}`)}
        >
          <Alert
            severity={state.alert.type}
            icon={<EAAlertIcon severity={state.alert.type} />}
            onClose={handleAlertClose}
            action={
              <IconButton
                style={{ marginLeft: "28px" }}
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => {
                  dispatch({ type: "ALERT", alert: null });
                }}
              >
                <EAAlertCloseIcon severity={state.alert.type} />
              </IconButton>
            }
          >
            {formatErrorMsg(state.alert.msg)}
            {state.alert.spinner && <EASpinner />}
          </Alert>
        </Snackbar>
      </Collapse>
    )
  );
};

export default EASnackBar;
